export enum ToastType {
	Success = 1,
	Warning,
	Error,
	Info
}
